/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GridSettings } from '../../models/grid-settings';
import { UserSettingType } from '../../models/user-setting-type';

export interface SaveGridSettings$Params {
  gmname?: string | null;
  settingType?: UserSettingType;
      body: GridSettings
}

export function saveGridSettings(http: HttpClient, rootUrl: string, params: SaveGridSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, saveGridSettings.PATH, 'post');
  if (params) {
    rb.query('gmname', params.gmname, {});
    rb.query('settingType', params.settingType, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

saveGridSettings.PATH = '/api/GridSettings/saveGridSettings';
